import { render, staticRenderFns } from "./FormControlOdpPartyBookingsResendEmail.vue?vue&type=template&id=21708ddc"
import script from "./FormControlOdpPartyBookingsResendEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlOdpPartyBookingsResendEmail.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports